import React, { useState } from 'react';
import styled from 'styled-components';

import {
  ActionIconTrash,
  ButtonRoundTertiary,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import { CY_DOCUMENTS_CONTAINER_IDS } from '@/containers/Documents/constants';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 50px;

  border-bottom: 1px solid #f0f1f1;
  padding: 10px 15px 10px 15px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: calc(100% - 40px);
`;

type ViewerProps = {
  onDeleteDocument: (doc: StakeholderDocument, callback: () => void) => void;
  documents: StakeholderDocument[];
};

const Viewer = ({ documents = [], onDeleteDocument }: ViewerProps): React.JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState<string[]>([]);

  const deleteDocument = (doc: StakeholderDocument) => () => {
    setDeleting(deleting => [...deleting, doc.attachmentId]);
    setLoading(true);
    onDeleteDocument(doc, () => {
      setDeleting(deleting => deleting.filter(element => element !== doc.attachmentId));
      setLoading(false);
    });
  };

  return (
    <>
      {documents.map(doc => (
        <Container key={doc.attachmentId}>
          <Title>
            <Typography
              textToken="text-style/text/paragraphs/default/regular"
              numberOfLines={1}
              {...generateCyElemId(CY_DOCUMENTS_CONTAINER_IDS.ELEMENT_DOCUMENT_VIEWER, window)}
            >
              {doc.filename}
            </Typography>

            <SpacerVertical spaceToken="space/100" />

            {doc.size && (
              <Typography
                textToken="text-style/text/paragraphs/default/regular"
                numberOfLines={1}
                colorToken="colors/text/neutral"
              >
                {doc.size}
              </Typography>
            )}
          </Title>

          <ButtonRoundTertiary
            size="small"
            loading={!!(loading && deleting.find(element => element === doc.attachmentId))}
            onClick={deleteDocument(doc)}
            aria-label="delete"
          >
            <ActionIconTrash />
          </ButtonRoundTertiary>
        </Container>
      ))}
    </>
  );
};

export default Viewer;
